import { useLanguage } from "@/contexts/LanguageContext";
import { Mail, Phone, MapPin, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-16">
      <div className="bg-secondary">
        <div className="container mx-auto py-16 px-4 md:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {t("contact.title")}
          </h1>
          <p className="text-xl text-muted-foreground">
            {t("contact.subtitle")}
          </p>
        </div>
      </div>

      <div className="container mx-auto py-12 px-4 md:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Informacje kontaktowe */}
          <div className="space-y-8">
            <h2 className="text-2xl font-bold mb-8">
              {t("contact.info.title")}
            </h2>

            {/* Email */}
            <div className="flex items-start p-6 bg-card rounded-lg hover:bg-card/80 transition-colors">
              <Mail className="mr-4 h-6 w-6 text-primary mt-1" />
              <div>
                <h3 className="font-semibold text-lg mb-2">Email</h3>
                <a
                  href="mailto:marta@arka.org.pl"
                  className="text-primary hover:underline"
                >
                  marta@arka.org.pl
                </a>
              </div>
            </div>

            {/* Telefon */}
            <div className="flex items-start p-6 bg-card rounded-lg hover:bg-card/80 transition-colors">
              <Phone className="mr-4 h-6 w-6 text-primary mt-1" />
              <div>
                <h3 className="font-semibold text-lg mb-2">
                  {t("contact.phone.title")}
                </h3>
                <p className="text-muted-foreground italic">
                  {t("contact.phone.soon")}
                </p>
              </div>
            </div>

            {/* Adres */}
            <div className="flex items-start p-6 bg-card rounded-lg hover:bg-card/80 transition-colors">
              <MapPin className="mr-4 h-6 w-6 text-primary mt-1" />
              <div>
                <h3 className="font-semibold text-lg mb-2">
                  {t("contact.address.title")}
                </h3>
                <address className="not-italic text-muted-foreground space-y-1">
                  <p>{t("contact.address.church")}</p>
                  <p>ul. Przybyszewskiego 56</p>
                  <p>60-356 Poznań</p>
                  <p>{t("contact.address.country")}</p>
                </address>
              </div>
            </div>
          </div>

          {/* Angels of East Africa */}
          <div className="flex flex-col justify-center">
            <div className="bg-secondary rounded-lg overflow-hidden">
              <div className="aspect-[16/9] relative">
                <img
                  src="/website.png"
                  alt="Machine Gun Preacher Website"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-8 space-y-6">
                <h2 className="text-2xl font-bold">{t("contact.aea.title")}</h2>
                <p className="text-muted-foreground leading-relaxed">
                  {t("contact.aea.description")}
                </p>
                <Button asChild className="w-full" variant="default">
                  <a
                    href="https://machinegunpreacher.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center"
                  >
                    <span>{t("contact.aea.button")}</span>
                    <ExternalLink className="ml-2 h-4 w-4" />
                  </a>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
